import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'lucide-react';
import DropdownNotification from './DropdownNotification';
import DropdownUser from './DropdownUser';
import LogoIcon from '../../../../images/logo/logo-icon.svg';
import DarkModeSwitcher from './DarkModeSwitcher';

interface HeaderProps {
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
  isDark?: boolean;
  onToggleDark?: () => void;
}

// Thanh trên admin theo màn AdminHeader: cao 80px, nền trắng, kẻ dưới; bên phải là
// công tắc giao diện tối, thông báo và menu người dùng. Dưới lg có nút mở menu trái + logo.
const Header = ({ sidebarOpen, setSidebarOpen, isDark, onToggleDark }: HeaderProps) => {
  return (
    <header className="adm-header">
      <div className="adm-header__start lg:hidden">
        <button
          type="button"
          aria-controls="sidebar"
          aria-label="Mở menu"
          onClick={(e) => {
            e.stopPropagation();
            setSidebarOpen(!sidebarOpen);
          }}
          className="adm-icon-btn"
        >
          <Menu size={20} aria-hidden="true" />
        </button>
        <Link className="block flex-shrink-0" to="/admin">
          <img src={LogoIcon} alt="Logo" />
        </Link>
      </div>

      <div className="adm-header__end">
        {onToggleDark && <DarkModeSwitcher isDark={!!isDark} onToggle={onToggleDark} />}
        <DropdownNotification />
        <DropdownUser />
      </div>
    </header>
  );
};

export default Header;
